export let Intent;

(function (Intent) {
  Intent["academyLesson"] = "learningCenter";
  Intent["academyTrack"] = "academyTrack";
  Intent["community"] = "community";
  Intent["communityStaging"] = "communityStaging";
  Intent["companygrader"] = "companygrader";
  Intent["connectIntegration"] = "connectIntegration";
  Intent["conversations"] = "conversations";
  Intent["crmDeals"] = "crmDeals";
  Intent["crmLeadManagement"] = "crmLeadManagement";
  Intent["fbCrm"] = "fbCrm";
  Intent["hubspotnetwork"] = "hubspotnetwork";
  Intent["landingpages"] = "landingpages";
  Intent["leadAds"] = "leadAds";
  Intent["learningCenter"] = "learningCenter";
  Intent["marketingAds"] = "marketingAds";
  Intent["marketingFreeLeadFlows"] = "marketingFreeLeadFlows";
  Intent["marketingFreeForms"] = "marketingFreeForms";
  Intent["marketingFreeEmail"] = "marketingFreeEmail";
  Intent["marketingFreeAnalytics"] = "marketingFreeAnalytics";
  Intent["marketplaceTheme"] = "marketplaceTheme";
  Intent["oauthAuthorization"] = "oauthAuthorization";
  Intent["purchase"] = "purchase";
  Intent["salesCalling"] = "salesCalling";
  Intent["salesContactProfile"] = "salesContactProfile";
  Intent["salesDocuments"] = "salesDocuments";
  Intent["salesEmailScheduling"] = "salesEmailScheduling";
  Intent["salesEmailTracking"] = "salesEmailTracking";
  Intent["salesFree"] = "salesFree";
  Intent["salesExtension"] = "salesExtension";
  Intent["salesMeetings"] = "salesMeetings";
  Intent["salesOutlook"] = "salesOutlook";
  Intent["salesO365"] = "salesO365";
  Intent["salesPro"] = "salesPro";
  Intent["salesProspects"] = "salesProspects";
  Intent["salesSequences"] = "salesSequences";
  Intent["salesTemplates"] = "salesTemplates";
  Intent["salesVsto"] = "salesVsto";
  Intent["salesInboxProfiles"] = "salesInboxProfiles";
  Intent["service"] = "service";
  Intent["slides"] = "slides";
  Intent["trial"] = "trial";
  Intent["blackAtInbound"] = "blackAtInbound";
})(Intent || (Intent = {}));